<template>
  <div>
    <search-box
      :columns="searchBoxColumns"
      @search="search"
      @btnReset="handleReset"
      :defaultValue="formData"
      :column="2"
    />
    <QS-common-table
      :data="tableData"
      :columns="tableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
    />
    <change-pay-account-dialog
      ref="changePayAccountDialogRef"
      @refresh="handleRefreshList"
    />
  </div>
</template>

<script>
import config from './config'
import changePayAccountDialog from './changePayAccountForm'
// eslint-disable-next-line import/no-cycle
import { maintenancePlanBindListApi, getRentPlanNamesApi } from './services'
import {
  maintenanceLikeByNameApi,
  getCompanyProviderLikeByNameApi,
} from '../maintenanceProject/services'

export default {
  name: 'leasePlan',
  components: {
    changePayAccountDialog,
  },
  data() {
    const { searchBoxColumns, tableColumns } = config.call(this)
    return {
      tableData: [],
      searchBoxColumns,
      tableColumns,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      formData: {},
    }
  },
  methods: {
    handleRefreshList() {
      this.maintenancePlanBindList()
    },
    // eslint-disable-next-line vue/no-unused-properties
    openRentPlanPage(row) {
      // 指定租赁方案详情页
      this.$router.push({
        path: '/car_to_lease/leaseScheme/detail',
        query: {
          orderType: 1,
          id: row.rentPlanId,
        },
      })
    },
    // 车辆→维保管理→维保项目管理，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openProjectPage(row) {
      this.$router.push({
        path: '/vehicle/maintenance/maintenanceProject',
        query: {
          id: row.itemId,
        },
      })
    },
    // 集团→采购→服务商管理→服务商列表，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openservicePage(row) {
      this.$router.push({
        path: '/purchaseNew/serviceProvider/list',
        query: {
          serviceId: row.serviceId,
        },
      })
    },
    // 集团→采购→服务商管理→维保入驻审核，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openCollaborationPage(row) {
      this.$router.push({
        path: '/purchaseNew/maintenanceReview/list',
        query: {
          id: row.collaborationId,
        },
      })
    },
    // 查看维保订单，车辆→维保管理→维保订单管理，租赁方案ID+合作关系ID+项目ID查询
    // eslint-disable-next-line vue/no-unused-properties
    searchOrder(row) {
      this.$router.push({
        path: '/vehicle/maintenance/list',
        query: {
          rentPlanId: row.rentPlanId,
          collaborationId: row.collaborationId,
          itemId: row.itemId,
        },
      })
    },
    // 更换付款账户
    // eslint-disable-next-line vue/no-unused-properties
    changePayAccount(row) {
      this.$refs.changePayAccountDialogRef.open(row)
    },
    handleReset() {
      this.formData = {}
      this.tableData = []
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.maintenancePlanBindList()
    },
    search(formData) {
      this.formData = formData
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.maintenancePlanBindList()
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.maintenancePlanBindList()
    },
    // 获取项目名称
    // eslint-disable-next-line vue/no-unused-properties
    getProjectNames(e) {
      this.getMaintenanceLikeByNameApi(e)
    },
    // eslint-disable-next-line vue/no-unused-properties
    getCompanyProviderName(e) {
      this.getCompanyProviderLikeByName(e)
    },
    // eslint-disable-next-line vue/no-unused-properties
    getRentPlanNames(e) {
      this.getRentPlanLikeByNames(e)
    },
    async maintenancePlanBindList() {
      const [err, _data] = await this.$to(
        maintenancePlanBindListApi({
          ...this.formData,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        }),
      )
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.paginationData.total = data.totalNum
          this.tableData = data.items
        }
      }
    },

    // 项目名称模糊查询
    async getMaintenanceLikeByNameApi(name) {
      const [err, _data] = await this.$to(maintenanceLikeByNameApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'itemId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = JSON.parse(JSON.stringify(newData))
            }
            return item
          })
        }
      }
    },
    // 获取服务商名称
    async getCompanyProviderLikeByName(name) {
      const [err, _data] = await this.$to(
        getCompanyProviderLikeByNameApi({ name }),
      )
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'serviceId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = JSON.parse(JSON.stringify(newData))
            }
            return item
          })
        }
      }
    },
    // 租赁方案名称
    async getRentPlanLikeByNames(name) {
      const [err, _data] = await this.$to(getRentPlanNamesApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'rentPlanId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = JSON.parse(JSON.stringify(newData))
            }
            return item
          })
        }
      }
    },
  },
  created() {
    const { itemId, collaborationId } = this.$route.query
    this.formData.itemId = itemId
    this.formData.collaborationId = collaborationId
    this.maintenancePlanBindList()
    this.getProjectNames()
  },
}
</script>

<style lang="scss" scoped></style>
